"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var launchbees_core_1 = require("./launchbees-core");
var launchbees = new launchbees_core_1.LaunchbeesCore();
if (window !== undefined) {
    window.launchbees = launchbees;
}
exports.default = launchbees;
